import type { Membership, Resource } from '@frameio/graphql-client/generated';
import { useActiveAccountId } from '@frameio/shared/contexts';
import { updateCacheAfterUserDeletion } from '@frameio/shared/utils/updateCacheAfterUserDeletion';
import type { DeleteMembershipArgs } from './useDeleteMembership';
import { useDeleteMembership } from './useDeleteMembership';
import { useResourceName } from './useResourceName';

type Props = {
  onBeginMutation?: (id: Membership['id']) => Promise<void>;
  onCompleteMutation?: (id: Membership['id']) => void;
  refetchQueries?: Parameters<typeof useDeleteMembership>[0]['refetchQueries'];
  resourceId: Resource['id'];
  resourceType: string;
};

export const useDeleteGuestMembership = ({
  onBeginMutation,
  onCompleteMutation,
  resourceId,
  resourceType,
}: Props) => {
  const resourceName = useResourceName(resourceId, resourceType);
  const accountId = useActiveAccountId();

  const { deleteMembership } = useDeleteMembership({
    onBeginMutation,
    onCompleteMutation,
    resourceId,
    resourceName,
    onUpdateCache: (cache, data) => {
      const deletedUserId = data.deleteMembership.membership.accountUser.id;
      updateCacheAfterUserDeletion(cache, deletedUserId, accountId);
    },
  });

  return ({ membershipId, memberName, refetchQueries }: DeleteMembershipArgs) =>
    deleteMembership({ membershipId, memberName, refetchQueries });
};
